<template lang="pug">
  .third-party-profile-defaults
    .row.defaults
      .use-for-all-subscriptions(v-if="userHasActiveSubs")
        .xs-12
          .checkbox-wrap.mt-5.mb-5.text-left
            MrInputCheckbox(v-model="use_payment_for_all_subscriptions" label="Use on all subscriptions")

      .default-billing
        .xs-12
          .checkbox-wrap.mt-5.mb-5.text-left
            MrInputCheckbox(v-model="is_default", label="Set as default payment method")

    .row.done-section
      button(v-if="!profileIsDirty" type="submit" @click.prevent="doneMethod").mr-btn.btn-fixed-width.font-xsmall.submit-btn Done
      button(v-if="profileIsDirty" type="submit" @click.prevent="updateDefaultsMethod").mr-btn.btn-fixed-width.font-xsmall.submit-btn Save
  
</template>

<script>
  import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
  import MrInputCheckbox from "../mrInputCheckbox";

  export default {
    name: "ThirdPartyProfileDefaults",
    components: {
      MrInputCheckbox
    },

    data() {
      return {
        initialIsDefault: null,
        initialUseOnAllSubs: null
      }
    },

    props: {
      doneMethod: {
        type: Function,
        required: true
      }
    },

    mounted() {
      this.initialIsDefault = this.editProfileForm.is_default;
      this.initialUseOnAllSubs = this.editProfileForm.use_payment_for_all_subscriptions;
    },

    methods: {
      ...mapActions('payments', [
        'updateDefaultPaymentProfile',
        'updatePaymentProfileForSubscriptions'
      ]),

      ...mapMutations('payments', [
        'updateIsDefault',
        'updateUseProfileForAllSubs'
      ]),

      updateDefaultsMethod() {
        if (!this.profileIsDirty) {
          return;
        }

        const payload = {
          paymentProfileId: this.editProfileForm.paymentProfileId
        };

        if (this.initialUseOnAllSubs != this.editProfileForm.use_payment_for_all_subscriptions) {
          payload.subIds = this.activeSubscriptionIds;
          this.updatePaymentProfileForSubscriptions(payload);
        }

        if (this.initialIsDefault != this.editProfileForm.is_default) {
          this.updateDefaultPaymentProfile(payload);
        }

        this.doneMethod();
      }
    },

    computed: {
      ...mapState('payments', [
        'savingProfile',
        'editProfileForm',
      ]),

      ...mapGetters('subscriptions', [
        'activeSubscriptionIds'
      ]),

      userHasActiveSubs() {
        return !!this.activeSubscriptionIds.length;
      },

      profileIsDirty() {
        return this.initialAmazonIsDefault != this.is_default || this.initialAmazonUseOnAllSubs != this.use_payment_for_all_subscriptions;
      },

      is_default: {
        get() {
          return this.editProfileForm.is_default;
        },

        set(value) {
          this.updateIsDefault(value);
        }
      },

      use_payment_for_all_subscriptions: {
        get() {
          return this.editProfileForm.use_payment_for_all_subscriptions;
        },

        set(value) {
          this.updateUseProfileForAllSubs(value);
        }
      }
    }
   }
</script>

<style scoped lang="stylus">
  .defaults
    margin 1em 0 2em

  .done-section
    margin-top 2em
    text-align center

</style>